export default __webpack_public_path__ + "img/chat-play.ca4cb378.svg";